import { defineKey as T } from 'ha/i18n';

export const STATE_NAME = 'booking';
export const LISTING_PHOTO_SIZE = '450x';
export const FORM_NAME = 'booking';
export const PAYMENT_TYPES = {
  newCard: T('New credit card'),
  alipay: T('alipay'),
  amex: T('amex'),
  bankTransfer_DE: T('bankTransfer_DE'),
  bankTransfer_IBAN: T('bankTransfer_IBAN'),
  bankTransfer_NL: T('bankTransfer_NL'),
  bcmc: T('bcmc'),
  jcb: T('jcb'),
  directEbanking: T('directEbanking'),
  dotpay: T('dotpay'),
  ebanking_FI: T('ebanking_FI'),
  giropay: T('giropay'),
  ideal: T('ideal'),
  maestro: T('maestro'),
  paypal: T('paypal'),
  sepadirectdebit: T('sepadirectdebit'),
  tenpay: T('tenpay'),
  unionpay: T('unionpay'),
  visa: T('visa'),
};
